import { ModeuleNotAvailable } from "components/ui/shared/ModuleNotAvailable"
import styled from "styled-components"

export const Forces = () => {
    return (
        <StyledForces>
            <ModeuleNotAvailable/>
        </StyledForces>
    )
}

const StyledForces = styled.div`
    flex: 1;
    width: 100%;
`